<template>
  <div class="mt-4 container-fluid">
    <div class="d-flex mb-4">
      <h3>{{ translations.page_title }}</h3>
    </div>

    <div class="d-flex mb-4">
      <b-spinner v-if="loading" small></b-spinner>
      <span v-else>Client: <b-link :to="`/onboarding/client/edit/${client.id}`">{{ client.display_name }}</b-link></span>
    </div>

    <b-card no-body>
      <b-card-header header-tag="nav">
        <b-nav card-header tabs>
          <b-nav-item v-for="tab in tabs" :key="tab.key" :to="tab.route" :active="isActive(tab.route)">
            {{ tab.title }}
          </b-nav-item>
        </b-nav>
      </b-card-header>

      <b-card-body>
        <slot/>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import translations from '@/translations';

const routePrefix = '/onboarding/clients';

export default {
  name: 'ClientBillingLayout',
  data() {
    return {
      client: {},
      loading: true,
      translations: translations.finance.client_configs,
      tabs: [
        {
          key: 'implementation-info',
          title: translations.finance.client_configs.implementation_information.nav_title,
          route: `${routePrefix}/${this.$route.params.clientId}/billing/implementation-info`,
        },
        {
          key: 'billing-config',
          title: translations.finance.client_configs.billing_configuration.nav_title,
          route: `${routePrefix}/${this.$route.params.clientId}/billing/config`,
        },
      ],
    };
  },
  methods: {
    isActive(route) {
      return this.$route.path.includes(route);
    },
  },
  async beforeMount() {
    const clientId = Number(this.$route.params.clientId);
    const initializationPromises = [
      this.$store.dispatch('Core/fetchClients'),
    ];
    await Promise.all(initializationPromises);

    this.client = this.$store.getters['Core/getClients'].find(c => c.id === clientId);
    this.loading = false;
  },
};
</script>
